<template>
  <van-popup
    :value="value"
    position="bottom"
    round
    @input="onVisibleChange"
  >
    <div class="jersey-color-picker">
      <div class="picker-title">选择颜色</div>
      <div class="color-list">
        <div
          v-for="color in colors"
          :key="color"
          class="color-item"
          @click="onSelect(color)"
        >
          <div
            class="color-dot"
            :style="{ backgroundColor: color }"
          />
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
Vue.use(Popup)

import { JERSEY_COLOR_OPTIONS } from '../utils/jersey-colors'

export default {
  name: 'WheelBattleJerseyColorPicker',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      default: function () {
        return JERSEY_COLOR_OPTIONS.slice()
      }
    }
  },
  methods: {
    onVisibleChange: function (visible) {
      this.$emit('input', visible)
    },
    onSelect: function (color) {
      this.$emit('select', color)
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped lang="scss">
.jersey-color-picker {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.picker-title {
  font-size: 15px;
  color: #666666;
  height: 45px;
  line-height: 45px;
  padding: 0 12px;
}

.color-list {
  max-height: 200px;
  overflow-y: auto;
  padding-bottom: 34px;
}

.color-item {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 48px;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e5e5;
}

.color-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #e5e5e5;
}
</style>
